import { render } from "./TariffMiniHome.vue?vue&type=template&id=684416ab&scoped=true"
import script from "./TariffMiniHome.vue?vue&type=script&lang=js"
export * from "./TariffMiniHome.vue?vue&type=script&lang=js"

import "./TariffMiniHome.vue?vue&type=style&index=0&id=684416ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684416ab"]])

export default __exports__